import {
    Box,
    Typography,
} from '@mui/material'
import {Image} from 'antd'
import ManageBanner from '../../../assets/mobile-app/manage-account-banner.png'
import Icon1 from '../../../assets/mobile-app/manage-account-icon1.png'
import Icon2 from '../../../assets/mobile-app/manage-account-icon2.png'
import Icon3 from '../../../assets/mobile-app/manage-account-icon3.png'
import { useTranslation } from 'react-i18next'
import { isTablet } from 'react-device-detect'

export const SMManageAccount: React.FC = () => {

    const { t } = useTranslation()

    const data = [
        {
            'icon': Icon1,
            'title': t('t278'),
            'content': t('t279'),
        },
        {
            'icon': Icon2,
            'title': t('t280'),
            'content': t('t281'),
        },
        {
            'icon': Icon3,
            'title': t('t282'),
            'content': t('t283'),
        }
    ]

    const renderItem = (index: number) => {
        return (
            <Box key={index} sx={{
                flex: '1',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'start',
                paddingLeft: '10px',
                paddingRight: '10px',
            }}>
                <Image src={data[index]['icon']} width={70} height={70} alt='' preview={false}></Image>
                <Typography fontSize={20} fontWeight={600} color={'#141F39'} paddingTop={'16px'}>
                    {data[index]['title']}
                </Typography>
                <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingTop={'12px'}>
                    {data[index]['content']}
                </Typography>
            </Box>
        )
    }

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
            }}
        >
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'row',
                paddingTop: '80px',
                paddingLeft: isTablet ? '40px' : '60px',
                paddingRight: isTablet ? '40px' : '60px',
            }}>
                <Box sx={{
                    flex: '1',
                    display: 'flex',
                    flexDirection: 'column',
                    paddingRight: isTablet ? '20px' : '50px',
                }}>
                    <Typography fontSize={32} fontWeight={700} color={'#141F39'}>
                        {t('t276')}
                    </Typography>

                    <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingTop={'16px'}>
                        {t('t277')}
                    </Typography>

                    <Box sx={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'start',
                        justifyContent: 'space-between',
                        paddingTop: '36px',
                    }}>
                        {data.map((item, index) => (
                            renderItem(index)
                        ))}
                    </Box>

                </Box>

                <Image src={ManageBanner} style={{objectFit: 'cover', borderRadius: '10px'}} width={isTablet ? 460 : 636} height={isTablet ? 396 : 548} alt='' preview={false}></Image>
            </Box>

        </Box >
    )
}

// ======================= EXPORT
export default SMManageAccount
